export const MOBILE_SCANS_FILTERS_LABELS = {
	INCLUDE_ZERO_ISSUE_TOGGLE_LABEL: 'Show scans with no Issues'
} as const;
